export enum MessageAttachmentTypesEnum {
	Event = '9077c00d-d156-40dd-85eb-935092e3699e',
	Picture = 'e2aebe0e-f685-49d8-8f3e-ebef85889313',
	Video = 'b46e3ee2-fa99-491a-82c9-2f62a2bbe20e',
	KudosToPastEvent = '829d0e3b-96e1-4849-9d0d-980d587a66d7'
}
